<template>
  <div
    class="misc-inner p-2 p-sm-3"
  >
    <div class="w-150 text-center">
      <!--error image -->
      <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex; size: 50%">
        <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>
      <h5 class="mb-3">
        {{ i18n.t('error.something_wrong') }}️
      </h5>
    </div>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

export default {
  name: 'ShowError',
  data() {
    return {
      i18n,
    }
  },
}
</script>

<style scoped>

</style>
